<script>
    import {Link} from "svelte-routing";
    import {api, store} from '../stores.js';

    import TopMenu from '../components/TopMenu.svelte';
    import Footer from '../components/Footer.svelte';

    const user = store('credentials', 'appUserAuth');
          user.load({login: $user.email, password: $user.pasport});
    
    let
        idRegPred = $user.idRegPred,
        list = [];
    
    try {
        list = JSON.parse($user.komanda);
    } catch (e) {}
    
    const handlerAddPeople = () => {
        list = [...list, ['', '', '']];
    }
    const handlerRemovePeople = (i) => {
        list = [...list.filter((it, inx) => inx !== i)];
    }
    
    const handlerSavePeople = async () => {
        await api('saveUserPeoples', {idRegPred, komanda: JSON.stringify(list)});
        await user.load({login: $user.email, password: $user.pasport});
    }
</script>

<TopMenu title="Панель" />

<div id="appCapsule">
    <div class="section mb-4">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="profile-head">
                    <div class="avatar">
                        <ion-icon name="card-outline" style="font-size: 64px"></ion-icon>
                    </div>
                    <div class="in">
                        <h3 class="name">{$user.name}</h3>
                        <h5 class="subtext">Профиль регионального представителя</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="section mt-2 mb-2">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="card mt-2">
                    <div class="card-header">
                        Команда
    
                        <button class="btn btn-link btn-icon btn-sm float-end" style="height: 20px;" data-bs-toggle="modal" data-bs-target="#edit-peoples">
                            <ion-icon name="create-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                        </button>
    
                        <div class="modal fade modalbox" id="edit-peoples" data-bs-backdrop="static" tabindex="-1" aria-hidden="true" style="display: none;">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Редактирование команды</h5>
                                        <a href="#" data-bs-dismiss="modal">Закрыть</a>
                                    </div>
                                    <div class="modal-body">
                                        <div class="table-responsive">
                                            <div class="row">
                                                <div class="col-12 col-md-6 col-lg-4"></div>
                                                <div class="col-12 col-md-6 col-lg-4"></div>
                                                <div class="col-12 col-md-6 col-lg-4"></div>
                                            </div>
    
                                            {#each list as [name, phone, link], i}
                                                <div class="row border-bottom pb-1 mb-1">
                                                    <div class="col-6 mb-1"><input type="text" class="form-control" placeholder="Имя" bind:value="{name}"></div>
                                                    <div class="col-6 mb-1"><input type="tel" class="form-control" placeholder="Телефон" bind:value="{phone}"></div>
                                                    <div class="col-11"><input type="url" class="form-control" placeholder="Ссылка" bind:value="{link}"></div>
                                                    <div class="col-1 d-flex align-items-center">
                                                        <button type="button" class="btn btn-danger btn-sm btn-icon w-100" on:click={() => handlerRemovePeople(i)}>
                                                            <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="remove"></ion-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            {/each}
                                            
                                            <div class="row justify-content-center mt-3">
                                                <div class="col-12 col-md-6">
                                                    <button type="button" class="btn btn-outline-primary btn-sm btn-block mb-1" on:click={handlerAddPeople}>
                                                        <ion-icon name="add" role="img" class="md hydrated" aria-label="add"></ion-icon> Добавить
                                                    </button>
    
                                                    <button type="button" class="btn btn-primary btn-block" on:click={handlerSavePeople} data-bs-toggle="modal" data-bs-target="#edit-peoples">
                                                        <ion-icon name="create-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon> Сохранить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    {#if $user.komanda === ''}
                        <div class="card-body text-center">
                            <p class="m-0">
                                <b>Нет данных</b><br>
                                Вы можете заполнить вашу команду, перейдя к редактированию
                                (<ion-icon name="create-outline" role="img" class="md hydrated" aria-label="edit" data-bs-toggle="modal" data-bs-target="#edit-peoples"></ion-icon>) .
                            </p>
                        </div>
                    {:else}
                        <div class="card-body p-0">
                            <ul class="listview image-listview border-top-0">
                                {#each list as [name, phone, link]}
                                    <li>
                                        <a href="{link}" target="_blank" class="item">
                                            <div class="in">
                                                <div>{name}<br>{phone}</div>
                                            </div>
                                        </a>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
    
    <div class="section mt-2 mb-4">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="card mt-2">
                    <div class="card-header">Город</div>
                    <div class="card-body">
                        <p class="card-text m-0">{$user.gorod}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="section">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="section-title">Быстрый переход</div>
                <div class="row">
                    <div class="col-12 mb-1">
                        <Link to="/products" class="card card-round comment-box my-1" style="color: #4F5050!important;">
                            <div class="card-body">
                                <p class="m-0">
                                    <b class="pb-2">Продукты</b><br>
                                    Просматривайте доступные продукты
                                </p>
                            </div>
                        </Link>
                    </div>
                    <div class="col-12 mb-1">
                        <Link to="/activity" class="card card-round comment-box my-1" style="color: #4F5050!important;">
                            <div class="card-body">
                                <p class="m-0">
                                    <b>Мероприятия</b><br>
                                    Управление мероприятиями и участниками
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<Footer />
